import React, { useRef, useEffect } from 'react'
import { useField } from 'formik'

import { IChoiceProps } from './interfaces'

import { Container, Field, Marker, Icon, Label } from './styles'

const Choice: React.FC<IChoiceProps> = (props) => {
  const [field, _, helpers] = useField(props.name)

  const initialValue = useRef(field.value)

  useEffect(() => {
    return () => {
      helpers.setValue(initialValue.current)
    }
  }, [])

  return (
    <Container>
      <Field {...field} {...props} value={props.value} />

      <Marker>
        <Icon name="check" />
      </Marker>

      <Label>{props.label}</Label>
    </Container>
  )
}

export default Choice
